import { ComponentClassNames } from '../../util/classNames';
import { ZIndex } from '../../util/styles/zIndex';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type StickyTopClassNames = ComponentClassNames<'stickyTop'>;

export const getClassNames = memoizeFunction(
  (topOffset: number, className?: string): StickyTopClassNames =>
    mergeStyleSets({
      stickyTop: [
        {
          position: 'sticky',
          top: topOffset,
          zIndex: ZIndex.PageLayoutSubHeader,
        },
        className,
      ],
    })
);
